<div class="threats-panel-wrapper" *transloco="let t">

  <!-- Map toggle + refresh + count -->
  <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
    <div class="d-flex align-items-center gap-1">
      <button type="button"
              class="btn locations-btn locations-btn--toggle locations-btn--sm"
              [ngClass]="{'locations-btn--active': isVisible}"
              (click)="toggleLayer.emit()"
              [title]="t('Toggle threat zones overlay on map')">
        <span *ngIf="!isVisible">{{ t('Show on Map') }}</span>
        <span *ngIf="isVisible">{{ t('Hide from Map') }}</span>
      </button>
      <button type="button"
              class="btn locations-btn locations-btn--secondary locations-btn--sm"
              (click)="refresh.emit()"
              [title]="t('Reload threat zones')">
        {{ t('Refresh') }}
      </button>
    </div>
    <span class="locations-count">{{ filtered.length }} / {{ items.length }} alert zones</span>
  </div>

  <!-- Severity legend (shown when layer is visible) -->
  <div *ngIf="isVisible" class="locations-legend-inline mb-3">
    <span class="locations-legend-item"><span class="locations-legend-dot" style="background:#8B0000"></span> Extreme</span>
    <span class="locations-legend-item"><span class="locations-legend-dot" style="background:#FF4500"></span> Severe</span>
    <span class="locations-legend-item"><span class="locations-legend-dot" style="background:#FFA500"></span> Moderate</span>
    <span class="locations-legend-item"><span class="locations-legend-dot" style="background:#FFD700"></span> Minor</span>
  </div>

  <!-- Search -->
  <div class="mb-3 locations-filter-grid">
    <input class="form-control form-control-sm"
           [placeholder]="t('Search event, area...')"
           [(ngModel)]="search"
           (input)="onListFilterChange()" />
  </div>

  <!-- Filters: category + severity side by side -->
  <div class="row g-2 mb-3 locations-filter-grid locations-filter-pair">
    <div class="col-12 col-md-6">
    <select class="form-select form-select-sm flex-fill min-w-0"
            [(ngModel)]="filterCategory"
            (change)="onListFilterChange()">
      <option value="">{{ t('All Categories') }}</option>
      <option *ngFor="let cat of availableCategories" [value]="cat.value">{{ t(cat.labelKey) }}</option>
    </select>
    </div>
    <div class="col-12 col-md-6">
    <select class="form-select form-select-sm flex-fill min-w-0"
            [(ngModel)]="filterSeverity"
            (change)="onListFilterChange()">
      <option value="">{{ t('All Severities') }}</option>
      <option value="Extreme">Extreme</option>
      <option value="Severe">Severe</option>
      <option value="Moderate">Moderate</option>
      <option value="Minor">Minor</option>
      <option value="Unknown">Unknown</option>
    </select>
    </div>
  </div>

  <!-- Country + worker proximity (uncomment to enable; wire (filtersChanged) on parent app-weather-alerts) -->
  <!--
    <div class="col-12 col-md-6">
      <select class="form-select form-select-sm"
              [(ngModel)]="filterCountry"
              (change)="onScopeChange()">
        <option value="">{{ t('My Country') }}</option>
        <option value="all">{{ t('All Countries') }}</option>
        <option value="US">United States</option>
        <option value="CA">Canada</option>
        <option value="GB">United Kingdom</option>
        <option value="AU">Australia</option>
        <option value="NZ">New Zealand</option>
        <option value="IE">Ireland</option>
      </select>
    </div>
  -->
  <div class="row g-2 mb-3 locations-filter-grid locations-filter-pair">
    <div class="col-12 col-md-6">
      <select class="form-select form-select-sm"
              [(ngModel)]="filterProximity"
              (change)="onScopeChange()">
        <option value="50">{{ t('Within 50 miles of workers') }}</option>
        <option value="100">{{ t('Within 100 miles of workers') }}</option>
        <option value="500">{{ t('Within 500 miles of workers') }}</option>
        <option value="1000">{{ t('Within 1000 miles of workers') }}</option>
        <option value="2500">{{ t('Within 2500 miles of workers') }}</option>
        <option value="5000">{{ t('Within 5000 miles of workers') }}</option>
        <option *ngIf="okService.isDemoAccount()" value="all">{{ t('All threats (no proximity)') }}</option>
      </select>
    </div>
  </div>

  <!-- Alert cards -->
  <div class="alerts-list">

    <div *ngIf="filtered.length === 0" class="locations-empty-state">
      <span *ngIf="loading">{{ t('Loading threats...') }}</span>
      <span *ngIf="!loading && items.length === 0">{{ t('No active threats') }}</span>
      <span *ngIf="!loading && items.length > 0">{{ t('No threats match your filters') }}</span>
    </div>

    <div class="card locations-card mb-2"
         *ngFor="let a of filtered"
         [style.border-left]="'4px solid ' + severityColor(a.severity)">

      <div class="card-header locations-card__header align-items-start">
        <div class="flex-grow-1 locations-min-width-0 me-1 locations-card__title">
          <div class="d-flex align-items-center gap-1 mb-1 flex-wrap">
            <span class="badge" [ngStyle]="severityBadgeStyle(a.severity)" [title]="severityTitle(a)">{{ a.severity }}</span>
            <span class="badge" [ngStyle]="categoryBadgeStyle(a.category)">{{ categoryLabel(a.category) }}</span>
            <span class="badge bg-dark" *ngIf="a.isPin">{{ t('Pin') }}</span>
            <span class="badge bg-secondary">{{ formatThreatLabel(a.event) }}</span>
          </div>
          <strong class="small">{{ a.areaDesc }}</strong>
        </div>
        <button type="button"
                class="btn locations-btn locations-btn--primary locations-btn--sm flex-shrink-0"
                (click)="onView(a)"
                [title]="t('Fly to on map')">
          {{ t('View') }}
        </button>
      </div>

      <div class="card-body locations-compact-body">
        <div *ngIf="a.headline && a.headline !== a.areaDesc" class="text-muted small mb-1 text-truncate" [title]="a.headline">
          {{ a.headline }}
        </div>
        <div *ngIf="a.description" class="text-muted small mb-1 locations-description" [title]="a.description">
          {{ a.description }}
        </div>
        <div class="text-muted small" *ngIf="a.effective || a.expires">
          <span class="me-2" *ngIf="a.effective"><strong>{{ t('From') }}</strong> {{ formatDate(a.effective) }}</span>
          <span *ngIf="a.expires"><strong>{{ t('Until') }}</strong> {{ formatDate(a.expires) }}</span>
        </div>
      </div>

    </div>
  </div>

</div>
